import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "p-6 bg-white dark:bg-gray-800 min-h-screen" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2 gap-4" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "flex items-center bg-gray-100 dark:bg-gray-700 rounded-lg p-1" }
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["onKeydown"]
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-center h-96"
}
const _hoisted_10 = {
  key: 1,
  class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
}
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "text-red-800 dark:text-red-200" }
const _hoisted_13 = {
  key: 2,
  class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-8 text-center"
}
const _hoisted_14 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_15 = { class: "font-mono font-medium" }
const _hoisted_16 = {
  key: 3,
  class: "bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-8 text-center"
}
const _hoisted_17 = { class: "text-sm text-gray-600 dark:text-gray-400 mb-4" }
const _hoisted_18 = { class: "font-mono font-medium" }
const _hoisted_19 = {
  key: 4,
  class: "bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-8 text-center"
}
const _hoisted_20 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_21 = { class: "font-mono font-medium" }
const _hoisted_22 = {
  key: 5,
  class: "bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
}
const _hoisted_23 = { class: "p-6 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800" }
const _hoisted_24 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" }
const _hoisted_25 = { class: "flex-1" }
const _hoisted_26 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_27 = { class: "text-xl font-semibold text-gray-900 dark:text-white" }
const _hoisted_28 = { class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400" }
const _hoisted_29 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_30 = { class: "font-medium text-blue-600 dark:text-blue-400" }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = ["title"]
const _hoisted_33 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_34 = {
  key: 1,
  class: "w-4 h-4 text-green-600 dark:text-green-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_35 = { class: "p-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800" }
const _hoisted_36 = { class: "relative" }
const _hoisted_37 = { class: "p-6" }
const _hoisted_38 = { class: "grid gap-3" }
const _hoisted_39 = { class: "flex-1 min-w-0" }
const _hoisted_40 = { class: "text-sm font-medium text-gray-900 dark:text-white truncate font-mono" }
const _hoisted_41 = { class: "flex-shrink-0 ml-4 flex items-center gap-2" }
const _hoisted_42 = ["title", "onClick"]
const _hoisted_43 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_44 = {
  key: 1,
  class: "w-4 h-4 text-green-600 dark:text-green-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_45 = {
  key: 0,
  class: "text-center py-8 text-gray-500 dark:text-gray-400"
}
const _hoisted_46 = {
  key: 6,
  class: "bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-8 text-center"
}
const _hoisted_47 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_48 = { class: "font-mono font-medium" }
const _hoisted_49 = {
  key: 0,
  class: "mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg text-left"
}
const _hoisted_50 = {
  key: 7,
  class: "bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 p-12 text-center"
}

import { ref, computed, onUnmounted } from 'vue'
import { dependencyGraphService } from '../../services/dependency-graph'
import type { WorkloadDependencies } from '../../types/dependency-graph'
import { logger } from '../../utils/logger'

// Component name for Vue DevTools
// @vue/component
const DEFAULT_ENVIRONMENT = 'production' as const


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'DependencyGraphPage'
},
  __name: 'index',
  setup(__props) {

/* eslint-disable vue/no-v-text */


const loading = ref(false)
const error = ref<string | null>(null)
const searchQuery = ref('')
const workloadDependencies = ref<WorkloadDependencies | null>(null)
const searchInputRef = ref<HTMLElement | null>(null)
const selectedEnvironment = ref<'staging' | 'production'>(DEFAULT_ENVIRONMENT)
const apiSearchQuery = ref('')
const copiedApi = ref<string | null>(null)
const copiedAll = ref(false)

const fetchWorkloadDependencies = async (workload: string) => {
  if (!workload.trim()) {
    return
  }

  try {
    loading.value = true
    error.value = null
    workloadDependencies.value = null

    const data = await dependencyGraphService.getWorkloadDependencies(
      workload.trim(),
      selectedEnvironment.value
    )

    // Validate data structure
    if (
      !data ||
      !data.workloadName ||
      typeof data.syntaxErrorFound !== 'boolean' ||
      typeof data.workloadFound !== 'boolean' ||
      typeof data.istioProxyFound !== 'boolean' ||
      !Array.isArray(data.apis)
    ) {
      throw new Error('Invalid response format from API')
    }

    workloadDependencies.value = data

    logger.log('Loaded dependencies for workload:', data.workloadName, 'APIs:', data.apis.length)
  } catch (err) {
    logger.error('Failed to fetch workload dependencies:', err)
    error.value = err instanceof Error ? err.message : 'Failed to fetch workload dependencies'
    workloadDependencies.value = null
  } finally {
    loading.value = false
  }
}

const changeEnvironment = (environment: 'staging' | 'production') => {
  if (selectedEnvironment.value !== environment) {
    selectedEnvironment.value = environment
    // If we have a workload loaded, reload it with new environment
    if (workloadDependencies.value?.workloadName) {
      fetchWorkloadDependencies(workloadDependencies.value.workloadName)
    }
  }
}

const searchWorkload = () => {
  if (!searchQuery.value.trim()) {
    return
  }

  const workload = searchQuery.value.trim()
  fetchWorkloadDependencies(workload)
}

const clearSearch = () => {
  searchQuery.value = ''
  workloadDependencies.value = null
  error.value = null
  apiSearchQuery.value = ''
}

// Filter APIs based on search query
const filteredApis = computed(() => {
  if (!workloadDependencies.value?.apis) return []
  if (!apiSearchQuery.value.trim()) return workloadDependencies.value.apis

  const query = apiSearchQuery.value.toLowerCase()
  return workloadDependencies.value.apis.filter((api) => api.toLowerCase().includes(query))
})

// Copy API name to clipboard
const copyApiName = async (api: string) => {
  try {
    await navigator.clipboard.writeText(api)
    copiedApi.value = api
    setTimeout(() => {
      copiedApi.value = null
    }, 2000)
  } catch (err) {
    logger.error('Failed to copy API name:', err)
  }
}

// Copy all API names to clipboard
const copyAllApis = async () => {
  if (!workloadDependencies.value?.apis) return

  try {
    const allApis = workloadDependencies.value.apis.join('\n')
    await navigator.clipboard.writeText(allApis)
    copiedAll.value = true
    setTimeout(() => {
      copiedAll.value = false
    }, 2000)
  } catch (err) {
    logger.error('Failed to copy all APIs:', err)
  }
}

onUnmounted(() => {
  // Cleanup if needed
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", null, [
          _createElementVNode("h1", {
            class: "text-3xl font-bold text-gray-900 dark:text-white mb-2",
            textContent: 'API Dependency Graph'
          }),
          _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Query a workload to see which APIs it calls internally ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap" }, "Environment:", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass([
                'px-4 py-2 rounded-md text-sm font-medium transition-colors',
                selectedEnvironment.value === 'staging'
                  ? 'bg-blue-600 text-white shadow-sm'
                  : 'text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
              ]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeEnvironment('staging')))
            }, " Staging ", 2),
            _createElementVNode("button", {
              class: _normalizeClass([
                'px-4 py-2 rounded-md text-sm font-medium transition-colors',
                selectedEnvironment.value === 'production'
                  ? 'bg-blue-600 text-white shadow-sm'
                  : 'text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
              ]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeEnvironment('production')))
            }, " Production ", 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[9] || (_cache[9] = _createElementVNode("label", {
        for: "workload-search-input",
        class: "sr-only"
      }, "Enter workload name", -1)),
      _createElementVNode("div", _hoisted_7, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
          _createElementVNode("svg", {
            class: "h-5 w-5 text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })
          ])
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          id: "workload-search-input",
          ref_key: "searchInputRef",
          ref: searchInputRef,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
          type: "text",
          class: "block w-full pl-10 pr-3 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
          placeholder: "Enter workload name (e.g., automation-ad-publishing-facebook-ad-processor-worker)",
          onKeydown: _withKeys(_withModifiers(searchWorkload, ["prevent"]), ["enter"])
        }, null, 40, _hoisted_8), [
          [_vModelText, searchQuery.value]
        ]),
        (searchQuery.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "absolute inset-y-0 right-0 pr-3 flex items-center",
              onClick: clearSearch
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("svg", {
                class: "h-5 w-5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4" }),
            _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, "Loading dependency data...")
          ], -1)
        ])))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[11] || (_cache[11] = _createElementVNode("svg", {
                class: "w-5 h-5 text-red-600 dark:text-red-400 mr-2",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _createElementVNode("p", _hoisted_12, _toDisplayString(error.value), 1)
            ]),
            (searchQuery.value.trim())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors",
                  onClick: searchWorkload
                }, " Retry "))
              : _createCommentVNode("", true)
          ]))
        : (workloadDependencies.value && workloadDependencies.value.syntaxErrorFound)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _cache[14] || (_cache[14] = _createElementVNode("svg", {
                class: "mx-auto h-12 w-12 text-red-400 mb-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, " Invalid Workload Name Format ", -1)),
              _createElementVNode("p", _hoisted_14, [
                _cache[12] || (_cache[12] = _createTextVNode(" The workload name ")),
                _createElementVNode("span", _hoisted_15, _toDisplayString(workloadDependencies.value.workloadName), 1),
                _cache[13] || (_cache[13] = _createTextVNode(" is not in the correct format. "))
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mt-2" }, [
                _createTextVNode(" Workload names must end with "),
                _createElementVNode("span", { class: "font-mono font-medium" }, "-api"),
                _createTextVNode(" or "),
                _createElementVNode("span", { class: "font-mono font-medium" }, "-worker"),
                _createTextVNode(". ")
              ], -1))
            ]))
          : (workloadDependencies.value && !workloadDependencies.value.workloadFound)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[19] || (_cache[19] = _createElementVNode("svg", {
                  class: "mx-auto h-12 w-12 text-orange-400 mb-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ], -1)),
                _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, "Workload Not Found", -1)),
                _createElementVNode("p", _hoisted_17, [
                  _cache[17] || (_cache[17] = _createTextVNode(" The workload ")),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(workloadDependencies.value.workloadName), 1),
                  _cache[18] || (_cache[18] = _createTextVNode(" was not found in the cluster. "))
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mb-4" }, " Please double-check that you have entered the correct workload name. ", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("a", {
                  href: "https://console.cloud.google.com/kubernetes/workload/overview?project=highlevel-backend",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
                }, [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 mr-2",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    })
                  ]),
                  _createTextVNode(" Verify in Google Cloud Console ")
                ], -1))
              ]))
            : (workloadDependencies.value && !workloadDependencies.value.istioProxyFound)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[25] || (_cache[25] = _createElementVNode("svg", {
                    class: "mx-auto h-12 w-12 text-green-400 mb-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ], -1)),
                  _cache[26] || (_cache[26] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, "🎉 Congratulations!", -1)),
                  _createElementVNode("p", _hoisted_20, [
                    _cache[23] || (_cache[23] = _createTextVNode(" Thank you! You have already moved ")),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(workloadDependencies.value.workloadName), 1),
                    _cache[24] || (_cache[24] = _createTextVNode(" away from Istio mesh. "))
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mt-2" }, " This workload doesn't make any internal API calls, so it no longer needs the istio-proxy sidecar. ", -1))
                ]))
              : (workloadDependencies.value && workloadDependencies.value.apis.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("h2", _hoisted_27, _toDisplayString(workloadDependencies.value.workloadName), 1),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(selectedEnvironment.value), 1)
                          ]),
                          _createElementVNode("p", _hoisted_29, [
                            _cache[28] || (_cache[28] = _createTextVNode(" This workload calls ")),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(workloadDependencies.value.apis.length), 1),
                            _createTextVNode(" API" + _toDisplayString(workloadDependencies.value.apis.length !== 1 ? 's' : ''), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("button", {
                            class: "px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors flex items-center gap-2 shadow-sm hover:shadow transition-shadow",
                            title: copiedAll.value ? 'Copied!' : 'Copy all API names',
                            onClick: copyAllApis
                          }, [
                            (!copiedAll.value)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_33, _cache[29] || (_cache[29] = [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                  }, null, -1)
                                ])))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_34, _cache[30] || (_cache[30] = [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M5 13l4 4L19 7"
                                  }, null, -1)
                                ]))),
                            _createElementVNode("span", null, _toDisplayString(copiedAll.value ? 'Copied!' : 'Copy All'), 1)
                          ], 8, _hoisted_32)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", {
                        for: "api-search-input",
                        class: "sr-only"
                      }, "Search APIs", -1)),
                      _createElementVNode("div", _hoisted_36, [
                        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
                          _createElementVNode("svg", {
                            class: "h-4 w-4 text-gray-400",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            })
                          ])
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "api-search-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((apiSearchQuery).value = $event)),
                          type: "text",
                          class: "block w-full pl-9 pr-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                          placeholder: "Search APIs..."
                        }, null, 512), [
                          [_vModelText, apiSearchQuery.value]
                        ]),
                        (apiSearchQuery.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "absolute inset-y-0 right-0 pr-3 flex items-center",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (apiSearchQuery.value = ''))
                            }, _cache[31] || (_cache[31] = [
                              _createElementVNode("svg", {
                                class: "h-4 w-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M6 18L18 6M6 6l12 12"
                                })
                              ], -1)
                            ])))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredApis.value, (api) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: api,
                            class: "flex items-center p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-blue-500 dark:hover:border-blue-400 hover:shadow-md transition-all duration-200 group"
                          }, [
                            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 bg-gradient-to-br from-green-100 to-emerald-100 dark:from-green-900/30 dark:to-emerald-900/30 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-200" }, [
                              _createElementVNode("svg", {
                                class: "w-5 h-5 text-green-600 dark:text-green-400",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("p", _hoisted_40, _toDisplayString(api), 1)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("button", {
                                class: "p-2 text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors opacity-0 group-hover:opacity-100",
                                title: copiedApi.value === api ? 'Copied!' : 'Copy API name',
                                onClick: ($event: any) => (copyApiName(api))
                              }, [
                                (copiedApi.value !== api)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_43, _cache[34] || (_cache[34] = [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                      }, null, -1)
                                    ])))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_44, _cache[35] || (_cache[35] = [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }, null, -1)
                                    ])))
                              ], 8, _hoisted_42),
                              _cache[36] || (_cache[36] = _createElementVNode("span", { class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400" }, " API Service ", -1))
                            ])
                          ]))
                        }), 128))
                      ]),
                      (filteredApis.value.length === 0 && apiSearchQuery.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("p", null, "No APIs match your search \"" + _toDisplayString(apiSearchQuery.value) + "\"", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (
        workloadDependencies.value &&
        workloadDependencies.value.apis.length === 0 &&
        workloadDependencies.value.workloadFound
      )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _cache[41] || (_cache[41] = _createElementVNode("svg", {
                        class: "mx-auto h-12 w-12 text-yellow-400 mb-4",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                      ], -1)),
                      _cache[42] || (_cache[42] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, " No API dependencies found ", -1)),
                      _createElementVNode("p", _hoisted_47, [
                        _cache[38] || (_cache[38] = _createTextVNode(" The workload ")),
                        _createElementVNode("span", _hoisted_48, _toDisplayString(workloadDependencies.value.workloadName), 1),
                        _cache[39] || (_cache[39] = _createTextVNode(" does not call any APIs internally. "))
                      ]),
                      (workloadDependencies.value.workloadName.endsWith('-worker'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, _cache[40] || (_cache[40] = [
                            _createStaticVNode("<div class=\"flex items-start\" data-v-40edcaf5><span class=\"text-xl mr-3\" data-v-40edcaf5>⚠️</span><div class=\"flex-1\" data-v-40edcaf5><p class=\"text-sm font-semibold text-blue-900 dark:text-blue-200 mb-2\" data-v-40edcaf5> This workload needs to move away from Istio mesh </p><ul class=\"text-xs text-blue-800 dark:text-blue-300 space-y-1.5 list-none\" data-v-40edcaf5><li data-v-40edcaf5> 🚀 <strong data-v-40edcaf5>Fewer pod restarts:</strong> Say goodbye to istio-proxy crashing parties! Your pods will finally get some peace and quiet. </li><li data-v-40edcaf5> 💾 <strong data-v-40edcaf5>Memory savings:</strong> Free up that precious RAM that istio-proxy was hoarding like a digital dragon. Your cluster will thank you! </li><li data-v-40edcaf5> 💰 <strong data-v-40edcaf5>Cost savings:</strong> No istio-proxy sidecar = less CPU usage per pod. Your cloud bill will do a happy dance! 💃 </li><li data-v-40edcaf5> 🎯 <strong data-v-40edcaf5>Mesh efficiency:</strong> Less traffic = happier mesh. Think of it as decluttering your service mesh&#39;s social calendar. </li><li data-v-40edcaf5> ⚡ <strong data-v-40edcaf5>Better performance:</strong> No API calls means no need for the mesh overhead. It&#39;s like removing unnecessary middlemen from your conversations! </li></ul></div></div>", 1)
                          ])))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_50, _cache[43] || (_cache[43] = [
                      _createElementVNode("svg", {
                        class: "mx-auto h-16 w-16 text-gray-400 mb-4",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        })
                      ], -1),
                      _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, "Search for a workload", -1),
                      _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400" }, " Enter a workload name above to see which APIs it calls internally ", -1)
                    ])))
  ]))
}
}

})